import MarginBanner from './MarginBanner';
import MarginSection from './MarginSection';
import AnalysisMargin from './AnalysisMargin';

function Margin() {
  return (
    <div>
      <MarginBanner />
      <div class="about about--style1 bg-color xts-section" >
        <MarginSection />
        <AnalysisMargin />
      </div>
    </div>
  );
}

export default Margin;